import { App, Button, Tooltip } from "antd";
import useActionDialogRefine from "hook/bailiff/dialog/useActionDialog";
import moment from "moment";
import React from "react";

import { HiOutlineArrowUturnLeft } from "react-icons/hi2";
import { useDispatch } from "react-redux";
import { setBailiffDialogKick } from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonPrev5s = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const { second, start } = useActionDialogRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION ------------------------
  const handlePrev5s = () => {
    if (second - 5 < start) return message.error("Đã đến giới hạn cuối");
    const fronzen = moment().valueOf();
    const prev = second - 5;
    const time = `change-${fronzen}-${prev}`;
    dispatch(setBailiffDialogKick(time));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Quay về 5s">
      <Button
        onClick={handlePrev5s}
        type="text"
        size="large"
        icon={<HiOutlineArrowUturnLeft />}
      />
    </Tooltip>
  );
};
export default ButtonPrev5s;
